import { Component, Vue } from "vue-property-decorator";
import { DalModule } from "../store/dal.module";

@Component
export default class AccountIdValdationMixin extends Vue {
    async validateAccountId() {
        const id = Number(this.$route.params.id);
        if (id) {
            const req = DalModule.accounts.find(
                c => c.account_id === id,
            );
            if (!req) {
                return this.$router.push({ name: "account-list" });
            }
        }
    }
}
